/**
 * Shared COD shipping helpers for Bambe Classy theme.
 * Config comes from window.BAMBE_SHIPPING (set in scripts-tag.liquid).
 */
(function (window) {
  'use strict';

  function cfg() {
    return window.BAMBE_SHIPPING || {};
  }

  function fee() {
    var n = Number(cfg().fee);
    if (!isFinite(n) || n < 0) n = Number(window.BAMBE_COD_DELIVERY_FEE);
    return isFinite(n) && n >= 0 ? n : 30;
  }

  function freeFrom() {
    var n = Number(cfg().freeFrom);
    if (!isFinite(n) || n < 0) n = Number(window.BAMBE_COD_FREE_FROM);
    return isFinite(n) && n >= 0 ? n : 400;
  }

  function freeTag() {
    return cfg().freeTag || 'FreeDelivery';
  }

  function normalizeTags(tags) {
    if (Array.isArray(tags)) return tags;
    if (typeof tags === 'string') {
      return tags.split(',').map(function (t) {
        return t.trim();
      });
    }
    return [];
  }

  function itemHasFreeTag(item) {
    if (!item) return false;
    var tags = item.product_tags || item.tags || (item.product && item.product.tags) || [];
    return normalizeTags(tags).indexOf(freeTag()) !== -1;
  }

  function cartHasFreeTag(cartOrItems) {
    var items = Array.isArray(cartOrItems)
      ? cartOrItems
      : (cartOrItems && cartOrItems.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (itemHasFreeTag(items[i])) return true;
    }
    return false;
  }

  /**
   * @param {number} subtotalMad - cart/discounted subtotal in store currency units
   * @param {boolean} hasFreeDeliveryTag
   * @returns {{ shipping: number, total: number, fee: number, freeFrom: number }}
   */
  function compute(subtotalMad, hasFreeDeliveryTag) {
    var f = fee();
    var min = freeFrom();
    var price = Number(subtotalMad) || 0;
    var shipping = price >= min || hasFreeDeliveryTag ? 0 : f;
    return {
      shipping: shipping,
      total: price + shipping,
      fee: f,
      freeFrom: min,
    };
  }

  function formatMoneyMad(cents) {
    var amount = Math.round((Number(cents) || 0) / 100);
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.cartStrings && window.cartStrings.money_format) {
      try {
        return Shopify.formatMoney(cents, window.cartStrings.money_format);
      } catch (e) {}
    }
    return amount + ' درهم';
  }

  /**
   * Update cart drawer shipping row + grand total from cart JSON.
   * FreeDelivery tags are often missing from /cart.js — pass hasFreeDeliveryTag when known.
   */
  function refreshDrawerTotals(cart, hasFreeDeliveryTag) {
    if (!cart) return null;
    var subEl = document.getElementById('CartDrawer-Subtotal');
    var shipEl = document.getElementById('CartDrawer-Shipping');
    var grandEl = document.getElementById('CartDrawer-GrandTotal');
    var summary = document.querySelector('.cart-drawer__summary');
    if (!subEl || !shipEl || !grandEl) return null;

    var shipRow = shipEl.closest('.cart-drawer__shipping');

    if (!cart.item_count) {
      subEl.textContent = formatMoneyMad(0);
      shipEl.textContent = formatMoneyMad(0);
      shipEl.setAttribute('data-bambe-shipping-cents', '0');
      grandEl.textContent = formatMoneyMad(0);
      grandEl.setAttribute('data-bambe-grand-cents', '0');
      if (shipRow) {
        shipRow.classList.remove('is-free', 'is-paid');
      }
      if (summary) summary.setAttribute('hidden', '');
      return { shipping: 0, total: 0, fee: fee(), freeFrom: freeFrom() };
    }

    if (summary) summary.removeAttribute('hidden');

    var tagged = typeof hasFreeDeliveryTag === 'boolean' ? hasFreeDeliveryTag : cartHasFreeTag(cart);
    var subtotalMad = Math.round((cart.total_price || 0) / 100);
    var result = compute(subtotalMad, tagged);
    var shippingCents = Math.round(result.shipping * 100);
    var grandCents = (cart.total_price || 0) + shippingCents;

    subEl.textContent = formatMoneyMad(cart.total_price);
    shipEl.textContent = result.shipping === 0 ? 'مجاني' : formatMoneyMad(shippingCents);
    shipEl.setAttribute('data-bambe-shipping-cents', String(shippingCents));
    if (shipRow) {
      shipRow.classList.toggle('is-free', result.shipping === 0);
      shipRow.classList.toggle('is-paid', result.shipping > 0);
    }
    grandEl.textContent = formatMoneyMad(grandCents);
    grandEl.setAttribute('data-bambe-grand-cents', String(grandCents));
    return result;
  }

  function repairDrawerTotalsIfEmpty() {
    var shipEl = document.getElementById('CartDrawer-Shipping');
    if (!shipEl) return;
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart.item_count) {
          refreshDrawerTotals(cart, false);
          return;
        }
        if (!shipEl.textContent.trim()) {
          refreshDrawerTotals(cart, false);
        }
      })
      .catch(function () {});
  }

  window.BambeShipping = {
    fee: fee,
    freeFrom: freeFrom,
    freeTag: freeTag,
    itemHasFreeTag: itemHasFreeTag,
    cartHasFreeTag: cartHasFreeTag,
    compute: compute,
    formatMoneyMad: formatMoneyMad,
    refreshDrawerTotals: refreshDrawerTotals,
    repairDrawerTotalsIfEmpty: repairDrawerTotalsIfEmpty,
  };

  // Keep legacy globals in sync for older checkout/thank-you code paths.
  window.BAMBE_COD_DELIVERY_FEE = fee();
  window.BAMBE_COD_FREE_FROM = freeFrom();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repairDrawerTotalsIfEmpty);
  } else {
    repairDrawerTotalsIfEmpty();
  }
})(window);
